import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const PageContainer = styled.div`
  ${tw`flex flex-col w-full h-full items-center justify-center`}
`;

const AddCarButtonSkeleton = styled.div`
  ${tw`absolute top-20 right-4 z-10 w-full max-w-full min-w-0 box-border`}
`;

const ButtonSkeleton = styled(Skeleton)`
  ${tw`h-10 w-24 rounded-md`}
`;

// TopCars Skeleton
const TopCarsSkeleton = styled.div`
  ${tw`w-full max-w-screen-xl flex flex-col items-center justify-center mt-8`}
`;

const TopCarsTitleSkeleton = styled(Skeleton)`
  ${tw`h-8 w-48 mb-10`}
`;

const CarsContainerSkeleton = styled.div`
  ${tw`w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 px-4`}
`;

const CarCardSkeleton = styled.div`
  ${tw`flex flex-col items-center bg-white rounded-lg overflow-hidden shadow-card`}
  height: 300px;
`;

const CarImageSkeleton = styled(Skeleton)`
  ${tw`w-full h-40`}
`;

const CarDetailsSkeleton = styled.div`
  ${tw`w-full p-4`}
`;

const CarTitleSkeleton = styled(Skeleton)`
  ${tw`h-6 w-32 mb-3`}
`;

const CarInfoSkeleton = styled(Skeleton)`
  ${tw`h-4 w-full mb-2`}
`;

const CarPriceSkeleton = styled(Skeleton)`
  ${tw`h-6 w-24 mt-3`}
`;

const CarActionsSkeleton = styled.div`
  ${tw`mt-2 flex justify-between w-full`}
`;

const ActionButtonSkeleton = styled(Skeleton)`
  ${tw`h-8 w-20 rounded-md`}
`;

const HostCarPageSkeleton: React.FC = () => {
  return (
    <PageContainer>
      <AddCarButtonSkeleton>
        <ButtonSkeleton />
      </AddCarButtonSkeleton>

      <TopCarsSkeleton>
        <TopCarsTitleSkeleton />
        <CarsContainerSkeleton>
          {/* Display 6 car card skeletons */}
          {Array(6)
            .fill(0)
            .map((_, index) => (
              <CarCardSkeleton key={index}>
                <CarImageSkeleton />
                <CarDetailsSkeleton>
                  <CarTitleSkeleton />
                  <CarInfoSkeleton />
                  <CarInfoSkeleton width="75%" />
                  <CarPriceSkeleton />
                  <CarActionsSkeleton>
                    <ActionButtonSkeleton />
                    <ActionButtonSkeleton />
                  </CarActionsSkeleton>
                </CarDetailsSkeleton>
              </CarCardSkeleton>
            ))}
        </CarsContainerSkeleton>
      </TopCarsSkeleton>
    </PageContainer>
  );
};

export default HostCarPageSkeleton;
